import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { EmailTemplate } from '../models/email.model';
import { EmailsService } from '../services/emails.service';

export const emailTemplateDataResolver = (
  route: ActivatedRouteSnapshot
): Observable<EmailTemplate | null> => {
  const router = inject(Router);
  const transactionsService = inject(EmailsService);

  return transactionsService.get$().pipe(
    map(res => res.data ?? null),
    catchError(error => {
      router.navigate(['/dashboard']);
      console.log(error);
      return of(null);
    })
  );
};
